import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { parse } from 'yaml'

import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useOrg } from '@/hooks'
import useValidateEndpoint from '@/hooks/useValidate'
import { ConfigDataScreen } from '@/screens/ComponentLibrary/components'
import { useGetCustomComponent } from '@/screens/ComponentLibrary/hooks'
import { parseComponentTypes } from '@/utils'
import { ComponentType } from '@/utils/api'

import { DataDumpCustomComponent } from './Editor'

export const parseDataDump = (
  orgSlug?: string | null,
  param?: { settings: DataDumpCustomComponent; name: string } | string | null
) => {
  if (!param || !orgSlug) return {}
  const data = parseComponentTypes(param, ComponentType.DataDump)
  const steps = parse(data?.settings.dataDump || '')
  return {
    data: steps.data,
    organization: orgSlug,
    schemaName: 'DataDumpConfig',
    schemaVersion: '1.0.0',
    version: '1.0.0',
  }
}

export const useParseRecipeData = (
  orgSlug?: string | null,
  param?: { settings: DataDumpCustomComponent; name: string } | string | null
) => {
  return useMemo(() => {
    return parseDataDump(orgSlug, param)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(param), orgSlug])
}

export const ConfigData = () => {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()
  const org = useOrg(orgID)
  const current = useGetCustomComponent<DataDumpCustomComponent>(componentID)

  const config = useParseRecipeData(org.data?.slug, current.data)
  const valid = useValidateEndpoint(config, componentID)

  return (
    <ConfigDataScreen
      config={config}
      current={current}
      org={org}
      rootName="Data dump"
      valid={valid}
    />
  )
}
